import request from './interceptor'

/**
 * 获取设备重量记录列表
 * @param {Object} params
 * @param {number} [params.page=1] - 页码
 * @param {number} [params.size=10] - 每页条数
 * @param {string} [params.device_code] - 设备编号
 */
export function getDeviceWeightLogs(params = {}) {
  const defaultParams = { page: 1, size: 10 }
  const finalParams = { ...defaultParams, ...params }
  return request({
    url: '/v1/device-weight-logs',
    method: 'get',
    params: finalParams
  })
}
